const GUEST_PAYMENT_ID_KEY = 'startus_guest_payment_id';

function randomHex(bytes = 16) {
    const values = new Uint8Array(bytes);
    window.crypto.getRandomValues(values);
    return Array.from(values, (value) => value.toString(16).padStart(2, '0')).join('');
}

export function getGuestPaymentId() {
    let guestId = window.localStorage.getItem(GUEST_PAYMENT_ID_KEY) || '';
    if (!/^gst_[a-f0-9]{32}$/.test(guestId)) {
        guestId = `gst_${randomHex()}`;
        window.localStorage.setItem(GUEST_PAYMENT_ID_KEY, guestId);
    }
    return guestId;
}
